/* eslint-disable @typescript-eslint/no-explicit-any */
import {
	AfterContentInit,
	Component,
	ContentChildren,
	Input,
	QueryList,
	TemplateRef,
	ViewChild
} from "@angular/core";
import {
	ControlContainer,
	ControlValueAccessor,
	FormControl,
	FormControlDirective,
	NG_VALUE_ACCESSOR,
	ReactiveFormsModule,
	ValidationErrors
} from "@angular/forms";
import { AutomataTemplateDirective } from "@shared/directives/automata-template.directive";
import { InputNumberTemplate } from "./types";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { CurrencyDirective } from "@shared/directives/currency.directive";
import { ValidationErrorsComponent } from "@shared/utils/forms/validation-errors/validation-errors.component";

@Component({
	selector: "app-input-number",
	imports: [
		CommonModule,
		TranslateModule,
		ReactiveFormsModule,
		CurrencyDirective,
		ValidationErrorsComponent
	],
	templateUrl: "./input-number.component.html",
	styleUrls: ["./input-number.component.scss"],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: InputNumberComponent,
			multi: true
		}
	]
})
export class InputNumberComponent
	implements ControlValueAccessor, AfterContentInit
{
	@ViewChild(FormControlDirective, { static: true })
	formControlDirective!: FormControlDirective;

	@Input()
	formControlName = "";

	@Input()
	mode: "currency" | "decimal" = "decimal";

	@Input()
	placeholder = "";

	@Input()
	label = "";

	@Input()
	helperText = "";

	@Input()
	isRequired = false;

	@Input()
	updateCurrencyProgrammatically = false;

	/**
	 * @deprecated Prop depreciada. Utilizar template leftInputGroup e/ou rightInputGroup
	 */
	@Input()
	inputGroupIconText = "";

	/**
	 * @deprecated Prop depreciada. Utilizar template leftInputGroup e/ou rightInputGroup
	 */
	@Input()
	inputGroupIconPosition: "left" | "right" = "left";

	@Input()
	loading = false;

	@Input()
	decimalPlaces = 2;

	@ContentChildren(AutomataTemplateDirective)
	private templates!: QueryList<AutomataTemplateDirective>;

	protected labelTemplate!: TemplateRef<unknown>;
	protected leftInputGroup!: TemplateRef<unknown>;
	protected rightInputGroup!: TemplateRef<unknown>;

	constructor(private controlContainer: ControlContainer) {}

	ngAfterContentInit(): void {
		this.setCustomTemplates();
	}

	private setCustomTemplates(): void {
		this.templates.forEach((item) => {
			switch (item.getType() as InputNumberTemplate) {
				case "labelTemplate":
					this.labelTemplate = item.template;
					break;
				case "leftInputGroup":
					this.leftInputGroup = item.template;
					break;
				case "rightInputGroup":
					this.rightInputGroup = item.template;
					break;
			}
		});
	}

	writeValue(obj: any): void {
		this.formControlDirective?.valueAccessor?.writeValue(obj);
	}
	registerOnChange(fn: any): void {
		this.formControlDirective?.valueAccessor?.registerOnChange(fn);
	}
	registerOnTouched(fn: any): void {
		this.formControlDirective?.valueAccessor?.registerOnTouched(fn);
	}

	setDisabledState(isDisabled: boolean): void {
		if (this.formControlDirective) {
			if (this.formControlDirective.valueAccessor?.setDisabledState) {
				this.formControlDirective.valueAccessor.setDisabledState(
					isDisabled
				);
			}
		}
	}

	get control(): FormControl | null {
		return this.controlContainer.control?.get(
			this.formControlName
		) as FormControl;
	}

	get errors(): ValidationErrors | null | undefined {
		return this.control?.errors;
	}

	get isDisabled(): boolean | undefined {
		return this.control?.disabled;
	}
}
